import React from 'react';
import {
  Flex,
  useColorMode,
  useIsMobileView,
  Heading,
  Text,
  typography,
  color,
} from 'deepstash-ui';
import { StoryApiResponse } from 'api/api.types';
import NextImage from 'src/components/image/NextImage';

const IMAGE_HEIGHT_DESKTOP = 520;
const IMAGE_HEIGHT_MOBILE = 200;

interface StoryPageHeaderProps {
  story: StoryApiResponse;
}

const StoryPageHeader: React.FC<StoryPageHeaderProps> = ({ story }) => {
  const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();

  return (
    <Flex flexDirection="column" width={'100%'} gridRowGap={16}>
      <Heading
        size="h1"
        {...typography.primaryHeadingFonts.large.bold}
        color={color[colorMode].text}
      >
        {story.title}
      </Heading>
      <Text
        {...typography.primaryTextFonts.large.regular}
        color={color[colorMode].textSecondary}
      >
        {story.intro}
      </Text>
      <Flex flexDirection="row">
        <Text
          {...typography.primaryTextFonts.large.semiBold}
          color={color[colorMode].textSecondary}
        >
          {`Deepstash Team • ${story.time_to_read} minute read`}
        </Text>
      </Flex>
      <NextImage
        imageUrl={
          story.image.startsWith('https://')
            ? story.image
            : story.image_compressed
        }
        blurhash={story.image_blurhash}
        wrapperStyle={{
          width: '100%',
          height: isMobileView ? IMAGE_HEIGHT_MOBILE : IMAGE_HEIGHT_DESKTOP,
          cursor: 'auto',
        }}
        priority
        alt={`${story.title} Image`}
      />
    </Flex>
  );
};

export default StoryPageHeader;
